import React, { useId, useState } from 'react';
import styled from 'styled-components';
import { Grid, TextInline } from '@cko/primitives';
import { IconActionTriangleRight } from '@cko/icons';
import { usePopper } from 'react-popper';
import { ThreeDotMenuItemNext } from '../ThreeDotMenuItemNext';
import { FloatingBox } from '../ThreeDotMenuNext';
const SubMenuContainer = styled.div `
  position: relative;
  width: 100%;
`;
const SubMenuLabel = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  padding: var(--layout-seed) var(--layout-soybean);

  &:hover {
    background-color: var(--action-bg-decorative-hover);
  }
`;
export const ThreeDotMenuSubMenuNext = ({ children, id, items, menuId = 'menu-sub-menu', showIcon = true, testId, text, textColor, ...rest }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [referenceRef, setReferenceRef] = useState(null);
    const [popperRef, setPopperRef] = useState(null);
    const { styles, attributes } = usePopper(referenceRef, popperRef, {
        placement: 'right-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 0],
                },
            },
            {
                name: 'flip',
                enabled: true,
            },
        ],
    });
    const randomId = useId();
    const referenceId = id || randomId;
    const subMenuId = menuId || `${referenceId}-submenu`;
    const show = () => {
        setIsVisible(true);
    };
    const hide = () => {
        setIsVisible(false);
    };
    const childOnClick = (e, onClick) => {
        onClick(e);
        setIsVisible(false);
    };
    if (!children && !items) {
        return null;
    }
    return (React.createElement(SubMenuContainer, { onMouseEnter: show, onMouseLeave: hide },
        React.createElement(SubMenuLabel, { "aria-controls": subMenuId, "aria-haspopup": "true", "data-testid": testId, id: referenceId, ref: setReferenceRef, ...rest },
            React.createElement(TextInline, { whiteSpace: "nowrap", color: textColor }, text),
            showIcon && React.createElement(IconActionTriangleRight, null)),
        isVisible && (React.createElement(FloatingBox, { "aria-labelledby": referenceId, id: subMenuId, ref: setPopperRef, role: "menu", style: styles.popper, ...attributes.popper },
            React.createElement(Grid, { gridGap: "var(--layout-seed)", backgroundColor: "var(--base-bg-primary)", mx: "var(--layout-seed)", boxShadow: "var(--control-e-sheep)" },
                children,
                items?.map((item) => (React.createElement(ThreeDotMenuItemNext, { ...item, key: item.text, onClick: (e) => childOnClick(e, item.onClick) }))))))));
};
